import localStorage from 'Browser/localStorage';
import Resizer from 'Components/Resizer';

const STACKED_WIDTH_MAX = '--screen-xs-max';

function getMarginHeight(el) {
  const cs = window.getComputedStyle(el);
  return parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
}

function setHeight(el, height) {
  el.style.height = `${height}px`;
}

function removeHeight(el) {
  el.style.removeProperty('height');
}

function getCssVar(name) {
  return window.getComputedStyle(document.documentElement).getPropertyValue(name);
}

export default class LayoutManager {
  constructor(requestEditor, responseEditor, minHeight) {
    this._requestEditor = requestEditor;
    this._responseEditor = responseEditor;

    this._requestContainer = document.getElementById('request-editor');
    this._responseContainer = document.getElementById('response-editor');

    this._panelTop = document.querySelector('.panel-top');
    this._panelBottom = document.querySelector('.panel-bottom');

    this._navbar = document.querySelector('.navbar');
    this._footer = document.querySelector('footer');

    this._minHeight = minHeight;

    this._stackedWidthMax = getCssVar(STACKED_WIDTH_MAX);

    this._resizer = new Resizer(this._panelTop, minHeight)
      .on('resize', newHeight => {
        localStorage.topPaneHeight = newHeight;

        this.update();
      });

    window.addEventListener('resize', () => {
      this.update();
    });
  }

  update() {
    if (!this._isStackedLayout()) {
      if (!this._initialHeightSet) {
        const availableHeight = this._getAvailableHeight();
        let topPaneHeight = availableHeight / 2;

        var parsed;
        if (localStorage.topPaneHeight) {
          parsed = parseInt(localStorage.topPaneHeight);

          if (parsed && parsed >= this._minHeight) {
            topPaneHeight = parsed;
          }
        }

        setHeight(this._panelTop, topPaneHeight);

        this._initialHeightSet = true;
      }

      this._setupEditorHeight(this._requestContainer);
      this._setupBottomPanelHeight();
      this._setupEditorHeight(this._responseContainer);
    } else {
      // remove height overrides
      removeHeight(this._panelTop);
      removeHeight(this._panelBottom);
      removeHeight(this._requestContainer);
      removeHeight(this._responseContainer);

      // force initialHeight setup to be done again if we return to non-stacked layout
      this._initialHeightSet = false;
    }

    this._requestEditor.resize();
    this._responseEditor.resize();
  }

  _isStackedLayout() {
    const m = window.matchMedia(`(max-width: ${this._stackedWidthMax})`);
    return m.matches;
  }

  _getAvailableHeight() {
    const winHeight = document.documentElement.clientHeight;
    const navbarHeight = this._navbar.offsetHeight +
      (this._navbar.offsetHeight ? getMarginHeight(this._navbar) : 0);
    const footerHeight = this._footer.offsetHeight + getMarginHeight(this._footer);

    return winHeight - navbarHeight - footerHeight;
  }

  _setupEditorHeight(editorContainer) {
    const container = editorContainer.parentNode;
    const containerHeight = container.offsetHeight;

    let sibHeight = 0;
    for (const child of editorContainer.parentNode.children) {
      if (child === editorContainer) {
        continue;
      }

      sibHeight += child.offsetHeight + getMarginHeight(child);
    }

    const editorExtra = getMarginHeight(editorContainer);

    setHeight(editorContainer, containerHeight - sibHeight - editorExtra);
  }

  _setupBottomPanelHeight() {
    setHeight(this._panelBottom, this._getAvailableHeight() - this._panelTop.offsetHeight - 15);
  }

  _adjustViewport(requestEditor, responseEditor, requestContainer, responseContainer) {
    this._setupEditorHeight(requestEditor, requestContainer);

    this._setupBottomPanelHeight();
    this._setupEditorHeight(responseEditor, responseContainer);
  }
}
